module.exports = __webpack_public_path__ + "okticon.db28723126138387cdf40680e6e0fa5d.woff";